export default "__VITE_ASSET__bb046e37__"